import React, { Component } from "react";
import PropTypes from "prop-types";

import { graphql } from "@apollo/client/react/hoc";
import compose from "lodash.flowright";
import { GET_WINE_SLUG } from "../../graphql/queries";
import urlPatterns from "../../urls";

import StyledLoading from "../../components/atoms/Loading/StyledLoading";

/**
 * Renders WineDetailsById component accessible by wine ID that redirects user to the WINE_DETAILS page
 * which is accessible by slug.
 * */
class WineDetailsById extends Component {
  static propTypes = {
    history: PropTypes.shape().isRequired,
    wineSlugQuery: PropTypes.shape({}).isRequired,
  };

  componentDidUpdate() {
    const { wineSlugQuery, history } = this.props;

    // Redirect to the slug-based URL. The destination route (WineDetails)
    // renders inside Layout, which handles prerenderReady.
    if (wineSlugQuery.wine && wineSlugQuery.wine.product.slug) {
      history.push(urlPatterns.WINE_DETAILS(wineSlugQuery.wine.product.slug));
    }
  }

  render() {
    const { wineSlugQuery } = this.props;
    if (wineSlugQuery.loading) return <StyledLoading />;
    return null;
  }
}

export default compose(
  graphql(GET_WINE_SLUG, {
    name: "wineSlugQuery",
    options: (props) => ({
      partialRefetch: true,
      variables: {
        id: props.match.params.id,
      },
    }),
  })
)(WineDetailsById);
